import React from 'react'
import { Link } from 'react-router-dom'
import Constant, { getTypeTags } from '../../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import axios from 'axios'
import Loader from '../../../common/Loader'
import CustomFooter from '../../../common/TableBottom'
import moment from 'moment'
import Select from 'react-select'
import Button from '../../../common/CustomComponents/Button'

class CruiseTripBookingList extends React.Component {
  state = {
    country_list: [],
    Booking_data: [],
    limit: 10,
    pageNumber: 0,
    disabled: false,
    keyword: '',
    bookingStatus: '',
    country: '',
    tripId: null,
    tripList: [],
    booking_date: '',
    customer_phone: null,
    isSearching: false,
    isCancelled: false,
    listHourFormat: 'today',
    buttonDisabled: false,
    type_tag: '',
    totalCount: 0,
    totalPages: 0,
    open: false,
  }

  debounceTimeout = null

  componentDidMount() {
    this.getCountries()
    this.getTripList()
    this.getBookingList()
  }

  componentWillUnmount() {
    // Clear timeout on unmount
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }
  }

  getCountries = async () => {
    await axios
      .get(Constant.getAPI() + '/multi-country/list-countries?show_all_countries=true', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name:
            localStorage.getItem('loged_In_role') === 'super-admin'
              ? ''
              : `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            country_list: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getTripList = async (country = '') => {
    await axios
      .get(Constant.getAPI() + '/trips/get-all-cruise-trips', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: country || localStorage.getItem('countryShortName'),
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            tripList: res.data.data.map((itm) => ({
              label: `${itm.name_en}/${itm.name_ar}`,
              value: itm.id,
            })),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getBookingList = async () => {
    this.setState({
      isSearching: true,
      open: true,
      Booking_data: [],
    })
    await axios
      .get(Constant.getAPI() + '/trips/get-trip-bookings', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: localStorage.getItem('countryShortName'),
        },
        params: {
          limit: this.state.limit,
          pageNumber: this.state.pageNumber,
          keyword: this.state.keyword,
          booking_status: this.state.bookingStatus,
          country: this.state.country,
          trip_id: this.state.tripId?.value,
          booking_date: this.state.booking_date,
          type_tag: this.state.type_tag,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            Booking_data: res.data.data,
            open: false,
            disabled: res.data.data?.pagination?.disabled,
            totalCount: res.data.data?.pagination?.count || 0,
            totalPages: res.data.data?.pagination?.pages || 0,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
        this.setState({
          open: false,
        })
      })
      .finally(() => {
        this.setState({
          isSearching: false,
        })
      })
  }

  handleChange = (event) => {
    const fieldName = event?.target?.name
    const fieldValue = event?.target?.value

    this.setState({
      [fieldName]: fieldValue,
    })

    // Auto-search with debounce for all filters except keyword
    if (fieldName !== 'keyword') {
      this.triggerAutoSearch()
    } else {
      // Debounce keyword search
      this.triggerDebouncedSearch()
    }
  }

  handleTripChange = (event) => {
    this.setState({
      tripId: event,
    })
    // Auto-search when trip changes
    this.triggerAutoSearch()
  }

  handleClear = () => {
    this.setState({ tripId: null })
  }

  searchData = async () => {
    this.setState(
      {
        limit: 10,
        pageNumber: 0,
      },
      () => {
        this.getBookingList()
      }
    )
  }

  clearFilters = () => {
    // Clear any pending debounce
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }

    this.setState(
      {
        tripId: '',
        country: '',
        type_tag: '',
        bookingStatus: '',
        booking_date: '',
        customer_phone: '',
        keyword: '',
        limit: 100,
        pageNumber: 0,
        Booking_data: [],
        totalCount: 0,
        totalPages: 0,
      },
      () => {
        // Auto-fetch data after clearing filters
        this.getBookingList()
      }
    )
  }

  triggerDebouncedSearch = () => {
    // Clear existing timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }

    // Set new timeout for keyword search (500ms delay)
    this.debounceTimeout = setTimeout(() => {
      this.setState(
        {
          limit: 10,
          pageNumber: 0,
        },
        () => {
          this.getBookingList()
        }
      )
    }, 500)
  }

  triggerAutoSearch = () => {
    // Clear existing timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }

    // Set new timeout for filter changes (300ms delay)
    this.debounceTimeout = setTimeout(() => {
      this.setState(
        {
          limit: 10,
          pageNumber: 0,
        },
        () => {
          this.getBookingList()
        }
      )
    }, 300)
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.searchData()
    }
  }

  changeBookingTagAndStatus = async (event, rowData) => {
    let data = {}

    let id = rowData[0]

    let temp_data = this.state.Booking_data
    temp_data.forEach((itm) => {
      if (itm.order_number == id) {
        itm[event.target.name] = event.target.value

        data.booking_id = itm.id
        data[event.target.name] = event.target.value
      }
    })

    this.setState({
      Booking_data: temp_data,
    })

    await this.updateStatus(data)
  }

  updateStatus = async (data) => {
    await axios
      .post(Constant?.getAPI() + `/trips/change-booking-details`, data, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          Swal.fire({
            toast: true,
            icon: 'success',
            position: 'top-end',
            title: `Updated`,
            text: 'Cruise details Updated',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 2500,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    const columns = [
      {
        name: 'order_number',
        label: 'Order No',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'customer_phone',
        label: 'Customer Phone',
        options: {
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'customer_name',
        label: 'Customer Name',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'trip_name',
        label: 'Trip Name',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            if (!value) return '--'
            const truncatedText = value.length > 20 ? value.substring(0, 20) + '...' : value
            return (
              <div style={{ display: 'flex', alignItems: 'center', textWrap: 'nowrap' }}>
                <span>{truncatedText}</span>
                {value.length > 20 && (
                  <i
                    className="icofont icofont-info-circle m-l-5"
                    style={{ cursor: 'pointer', color: '#007bff' }}
                    title={value}
                  ></i>
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'start_date',
        label: 'Booking Start Date',
        options: {
          customBodyRender: (value) =>
            value ? (
              <div style={{ textWrap: 'nowrap' }}>{moment(value, 'YYYY-MM-DD').format('DD MMM YYYY')}</div>
            ) : (
              '--'
            ),
        },
      },
      {
        name: 'end_date',
        label: 'Booking End Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) =>
            value ? (
              <div style={{ textWrap: 'nowrap' }}>{moment(value, 'YYYY-MM-DD').format('DD MMM YYYY')}</div>
            ) : (
              '--'
            ),
        },
      },
      {
        name: 'created_at',
        label: 'Issued Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) =>
            value ? (
              <div style={{ textWrap: 'nowrap' }}>{moment(value, 'YYYY-MM-DD').format('DD MMM YYYY')}</div>
            ) : (
              '--'
            ),
        },
      },
      {
        name: 'total_booking_amount',
        label: 'Total Booking Amount',
      },
      {
        name: 'wallet_amount_applied',
        label: 'Wallet Applied Amount',
      },
      {
        name: 'coupon_applied_amount',
        label: 'Coupon Applied Amount',
      },
      {
        name: 'coupon_code',
        label: 'Coupon Code',
        options: {
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'payment_status',
        label: 'Payment status',
        options: {
          customBodyRender: (payment_status) => {
            return (
              <div>
                {payment_status === true ? (
                  <span className="badge badge-pill badge-success">Success</span>
                ) : (
                  <span className="badge badge-pill badge-warning">Pending</span>
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'payment_method',
        label: 'Payment Method',
        options: {
          customBodyRender: (value) => {
            return value && value.length > 0 ? value.join('\n') : '--'
          },
        },
      },
      {
        name: 'country',
        label: 'Country',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'booking_status',
        label: 'Booking Status',
        options: {
          customBodyRender: (value, { rowData }) => {
            return (
              <>
                <select
                  style={{ minWidth: 150 }}
                  name="booking_status"
                  className={`form-control`}
                  value={value}
                  onChange={(event) => this.changeBookingTagAndStatus(event, rowData)}
                >
                  <option value={''}>N/A</option>
                  <option value="Pending">Pending</option>
                  <option value="Confirmed">Confirmed</option>
                  <option value="Successful">Successful</option>
                  <option value="Postponed">Postponed</option>
                  <option value="Cancelled">Cancelled</option>
                </select>
              </>
            )
          },
        },
      },
      {
        name: 'type_tag',
        label: 'Type Tag',
        options: {
          customBodyRender: (value, { rowData }) => {
            return (
              <>
                <select
                  style={{ minWidth: 150 }}
                  name="type_tag"
                  className="form-control"
                  value={value}
                  onChange={(event) => this.changeBookingTagAndStatus(event, rowData)}
                >
                  <option value={''}>N/A</option>
                  {getTypeTags().map((itm) => (
                    <option
                      value={itm}
                      key={itm}
                    >
                      {itm}
                    </option>
                  ))}
                </select>
              </>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Action',
        options: {
          customBodyRender: (booking_id) => {
            return (
              <div>
                <Link
                  to={'/cruise-trip-booking-details/' + booking_id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="View "
                >
                  <i className="f-22 icofont icofont-eye text-dark"></i>
                </Link>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      filter: false,
      viewColumns: false,
      selectableRows: 'none',
      download: false,
      search: false,
      print: false,
      count: this.state.totalCount || 0,
      page: this.state.pageNumber,
      rowsPerPage: this.state.limit,
      rowsPerPageOptions: [10, 20, 50, 100],
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            count={this.state.limit}
            pageNumber={this.state.pageNumber}
            totalPages={this.state.totalPages}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState({
          pageNumber: currentPage,
        }, () => {
          this.getBookingList()
        })
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState({
          limit: numberOfRows,
          pageNumber: 0,
        }, () => {
          this.getBookingList()
        })
      },
      textLabels: {
        body: {
          noMatch: this.state.open ? <Loader open={this.state.open} /> : 'Sorry, No Booking Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <>
        <div className="page-body">
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-border-default">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4 col-sm-12">
                      <div className="form-group row">
                        <label className="col-4 col-form-label">Search</label>
                        <div className="col-8">
                          <input
                            type="text"
                            id="keyword"
                            className="form-control"
                            value={this.state.keyword}
                            name="keyword"
                            placeholder={`Order No | Order Reference Id | Customer Name`}
                            onKeyPress={this.handleKeyPress}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-12">
                      <div className="form-group row">
                        <label className="col-4 col-form-label">Booking Status</label>
                        <div className="col-8">
                          <select
                            name="bookingStatus"
                            className="form-control"
                            value={this.state.bookingStatus}
                            onChange={this.handleChange}
                          >
                            <option value={''}>All</option>
                            <option value={'Pending'}>Pending</option>
                            <option value={'Successful'}>Successful</option>
                            <option value={'Cancelled'}>Cancelled</option>
                            <option value={'Confirmed'}>Confirmed</option>
                            <option value={'Postponed'}>Postponed</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-12">
                      <div className="form-group row">
                        <label className="col-4 col-form-label">Country</label>
                        <div className="col-8">
                          <select
                            name="country"
                            className="form-control"
                            value={this.state.country}
                            onChange={this.handleChange}
                          >
                            <option value={''}>All</option>
                            {this.state.country_list.map((country) => (
                              <option
                                value={country.country_short_name}
                                key={country.country_short_name}
                              >
                                {country.country_name_en + '/' + country.country_name_ar}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-12">
                      <div className="form-group row">
                        <label className="col-4 col-form-label">Trip Name</label>
                        <div className="col-8">
                          <Select
                            name="tripId"
                            value={this.state.tripId}
                            onChange={this.handleTripChange}
                            options={this.state.tripList}
                            isMulti={false}
                            isSearchable={true}
                            isClearable
                            onClear={this.handleClear}
                            placeholder="Select Trip"
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              menu: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-md-4 col-sm-12">
                      <div className="form-group row">
                        <label className="col-4 col-form-label">Booking Date</label>
                        <div className="col-8">
                          <input
                            type="date"
                            className="form-control"
                            name="booking_date"
                            value={this.state.booking_date}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    <div className="col-md-4 col-sm-12">
                      <div className="form-group row">
                        <label className="col-4 col-form-label">Type Tag</label>
                        <div className="col-8">
                          <select
                            name="type_tag"
                            className="form-control"
                            value={this.state.type_tag}
                            onChange={this.handleChange}
                          >
                            <option value={''}>All</option>
                            {getTypeTags().map((itm) => (
                              <option
                                value={itm}
                                key={itm}
                              >
                                {itm}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group row">
                        <div className="col-12">
                          <Button
                            disabled={this.state.isSearching}
                            onClick={this.searchData}
                          >
                            {this.state.isSearching ? 'Searching...!' : 'Search'}
                          </Button>
                          <Button
                            disabled={this.state.isSearching}
                            onClick={this.clearFilters}
                            variant="outlined"
                          >
                            Clear
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-body">
          <div className="row">
            <div className="col-sm-12">
              <div className="dt-responsive table-responsive">
                <MUIDataTable
                  className="table-responsive"
                  data={this.state.Booking_data}
                  columns={columns}
                  options={options}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default CruiseTripBookingList
